/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Generate_ReportsInputs */



/**
* | output |
* | --- |
* | "Generate reports and meeting summaries" |
*
* @param {Onboarding_Usage_Generate_ReportsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_generate_reports = /** @type {((inputs?: Onboarding_Usage_Generate_ReportsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Generate_ReportsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Berichte und Besprechungsprotokolle erstellen")
	return /** @type {LocalizedString} */ ("Generate reports and meeting summaries")
});